module.exports = __webpack_public_path__ + "img/guess.1f87a2a7.svg";